import React from 'react';
import { Modal } from '../../../components/Modal/Modal.component';
import { ExaminerFunction } from '../../Assessment/Assessment.types';
import { SessionsCopyDialogContent } from './SessionsCopyDialogContent.component';

interface SessionsCopyDialogProps {
  onClose: () => void;
  open: boolean;
  sheetId: string;
  id: string;
  title: string;
}

export const SessionsCopyDialog: React.FC<SessionsCopyDialogProps> = ({ onClose, open, sheetId, id, title }) => {
  return (
    <Modal xCloseButton={() => onClose()} id={id} open={open} size="xl" heightReducing title={title}>
      <SessionsCopyDialogContent sheetId={sheetId} onClose={() => onClose()} />
    </Modal>
  );
};
